/**
 * Servicio API para el feature entregas
 *
 * Maneja todas las llamadas HTTP necesarias para el dashboard TV de entregas.
 * Feature completamente autocontenido.
 *
 * @module features/entregas/api/entregas.api
 */

import axios from 'axios';
import AuthService from '../../../services/auth.service';
import HostService from '../../../services/host.service';
import ConfigService from '../../../services/config.service';

class EntregasService {
    /**
     * Obtiene los estados de entregas (deliveries) por ruta para un año específico
     *
     * Endpoint: GET /ventas/{year}/estados-tv
     * Documentación: ../api/docs/api/ventas.md
     *
     * @param {number} year - Año para filtrar las entregas
     * @returns {Promise<Array>} Array de objetos delivery con estructura:
     *   - nombreRuta: string - Nombre de la ruta ("tenerife" | "ruta islas" | "mostrador")
     *   - sinPreparar: number - Pedidos sin preparar (estado "1")
     *   - preparados: number - Pedidos preparados (estado "3")
     *   - enRevision: number - Pedidos en revisión (estado "4")
     *   - total: number - Total de pedidos
     *   - pedidosPorRuta: Object - Desglose por sub-ruta (ej: {"TCI NOR 1": 5, "TCI NOR 2": 7})
     */
    static async getEstados(year) {
        try {
            const response = await axios.get(
                `${HostService.getHost()}ventas/${year}/estados-tv`,
                AuthService.setToken()
            );
            // La API devuelve { data: [...], message: "..." }
            // Extraemos el array de deliveries del wrapper
            return response.data?.data ?? [];
        } catch (error) {
            console.error('Error al obtener estados de entregas:', error);
            throw error;
        }
    }

    /**
     * Obtiene el valor de configuración de la marquesina
     *
     * @param {string} configKey - Clave de configuración ('marquesina' o 'marquesina_desp')
     * @returns {Promise<Object>} Objeto con estructura { nombre, value }
     */
    static async getConfigMarquesina(configKey) {
        try {
            return await ConfigService.getConfig(configKey);
        } catch (error) {
            console.error(`Error al obtener configuración ${configKey}:`, error);
            throw error;
        }
    }
}

export default EntregasService;
